import { render, staticRenderFns } from "./AdminBookingList.vue?vue&type=template&id=2c081a68"
import script from "./AdminBookingList.vue?vue&type=script&lang=js"
export * from "./AdminBookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports